export const translations = {
    tr: {
        topbar: {
            campaigns: 'Kampanyalar',
            orders: 'Siparişlerim',
            about: 'Hakkımızda',
            newSeason: 'Yeni Sezon Ürünleri',
            categoriesAria: 'Ürün kategorileri',
            searchPlaceholder: 'Dilediğinizi Arayın',
            login: 'Giriş Yap',
            account: 'Hesabım',
            favorites: 'Favoriler',
            cart: 'Sepetim',
            cartAria: 'Sepette {{count}} ürün var',
            collectionSuffix: 'Koleksiyonu',
            viewAll: 'Tümünü Gör',
            promoBadge: 'Yeni Sezon',
            promoTitle: 'Şehir Stiline Yeni Dokunuş',
            promoText: 'Premium kumaşlar, zamansız kesimler ve sınırlı stok fırsatlarıyla sezonun öne çıkan parçalarını keşfedin.',
            promoCta: 'Koleksiyonu İncele',
            promoImageAlt: 'Yeni sezon kampanya görseli',
            profileAccount: 'Hesabım',
            profileOrders: 'Siparişlerim',
            profileAddresses: 'Adreslerim',
            profileReviews: 'Değerlendirmelerim',
            profileMessages: 'Satıcı Mesajlarım',
            logout: 'Çıkış Yap',
            language: 'Dil'
        },
        home: {
            heroPill: 'Trend Burada Özel',
            heroText: 'Sezonun öne çıkan parçalarını kaçırmadan keşfedin.',
            featuredCollections: 'Öne Çıkan Koleksiyonlar',
            allCampaigns: 'Tüm Kampanyalar',
            categorySpotlightTitle: 'Kategorileri Keşfet',
            discountTitle: 'İndirim Kampanyaları',
            discoverTitle: 'Stiline uygun parçaları tek ekranda bul.',
            specialOffers: 'Sana Özel Fırsatlar',
            seeAll: 'Hepsini Gör'
        },
        common: {
            previousSlide: 'Önceki slide',
            nextSlide: 'Sonraki slide',
            suggestions: 'Öneriler',
            passwordRuleLower: 'En az bir küçük harf',
            passwordRuleUpper: 'En az bir büyük harf',
            passwordRuleNumeric: 'En az bir rakam',
            passwordRuleMin: 'Minimum 7 karakter'
        },
        loginPage: {
            title: 'Hesabına Giriş Yap',
            subtitle: 'Siparişlerini takip et, favorilerini kaydet ve sana özel kampanyaları kaçırma.',
            loginTab: 'Giriş Yap',
            registerTab: 'Üye Ol'
        },
        login: {
            email: 'E-Posta',
            emailPlaceholder: 'E-Posta Adresi',
            password: 'Şifre',
            passwordPlaceholder: 'Kullanıcı Şifresi',
            forgot: 'Şifremi Unuttum',
            submit: 'Giriş Yap',
            or: 'veya',
            facebook: 'Facebook ile Devam Et',
            google: 'Google ile Devam Et',
            invalidCreds: 'Kullanıcı adı veya şifre hatalı',
            invalidEmail: 'Lütfen geçerli bir e-posta adresi giriniz',
            invalidPassword: 'Lütfen şifrenizi giriniz'
        },
        register: {
            name: 'Ad',
            surname: 'Soyad',
            email: 'E-Posta',
            password: 'Şifre',
            submit: 'Üye Ol',
            success: 'Kayıt başarılı. Şimdi Giriş Yap sekmesinden giriş yapabilirsiniz.',
            genericError: 'Kayıt esnasında hata oluştu.',
            invalidEmail: 'Lütfen geçerli bir e-posta adresi giriniz',
            invalidName: 'Lütfen adınızı giriniz',
            invalidSurname: 'Lütfen soyadınızı giriniz',
            invalidPassword: 'Lütfen belirleyeceğiniz şifrenizi giriniz',
            weakPassword: 'Lütfen daha uygun bir şifre belirleyin',
            passwordHint: 'Şifreniz en az 7 karakter olmalı, harf ve karakter içermelidir.',
            or: 'veya',
            facebook: 'Facebook ile Devam Et',
            google: 'Google ile Devam Et'
        },
        favorites: {
            title: 'Favorilerim',
            productCount: '{{count}} ürün',
            loading: 'Favoriler yükleniyor...',
            emptyTitle: 'Henüz favori ürününüz yok',
            emptyText: 'Beğendiğiniz ürünlerin kalp ikonuna tıklayarak bu alana ekleyebilirsiniz.',
            startShopping: 'Alışverişe Başla'
        },
        productList: {
            listingCount: '{{count}} ürün listeleniyor',
            loading: 'Ürünler yükleniyor...',
            empty: 'Seçili filtrelere uygun ürün bulunamadı. Farklı filtre kombinasyonları deneyin.'
        },
        productCard: {
            fastDelivery: 'Hızlı Teslimat',
            addFavorite: 'Favorilere ekle',
            removeFavorite: 'Favorilerden çıkar',
            sellerScore: 'Satıcı Puanı',
            freeCargo: 'Kargo Bedava'
        },
        productFilter: {
            categories: 'Kategoriler',
            searchPlaceholder: '{{title}} ara',
            noResult: 'Sonuç bulunamadı',
            showFilters: 'Filtreleri Göster',
            hideFilters: 'Filtreleri Gizle',
            clearFilters: 'Temizle',
            apply: 'Uygula',
            cancel: 'Vazgeç',
            mobileFilterAria: 'Filtre sekmeleri',
            brand: 'Marka',
            size: 'Beden',
            color: 'Renk',
            price: 'Fiyat',
            rating: 'Değerlendirme',
            sellerScore: 'Satıcı Puanı',
            discount: 'İndirim',
            delivery: 'Teslimat',
            shipping: 'Kargo',
            paymentOption: 'Ödeme Seçeneği'
        },
        productDetail: {
            home: 'Anasayfa',
            reviewsLabel: 'değerlendirme',
            qaLabel: 'soru-cevap',
            fastDelivery: 'Hızlı Teslimat',
            freeCargo: 'Kargo Bedava',
            seller: 'Satıcı',
            sellerStoreSuffix: 'Mağazası',
            sellerScore: 'Satıcı puanı',
            estimatedDelivery: 'Tahmini Teslimat',
            addToCart: 'Sepete Ekle',
            addedToCart: 'Ürün sepete eklendi.',
            productFeatures: 'Ürün Özellikleri',
            summary: 'Ürün Özeti',
            summaryText: '{{title}}, günlük kullanıma uygun modern kesimi ve konforlu yapısıyla öne çıkar. Farklı kombinlere kolay uyum sağlayan bu parça, sezonun öne çıkan seçimleri arasında yer alır.',
            discount: '%{{count}} indirim',
            feedbackTitle: 'Kullanıcı Yorumları ve Soru-Cevap',
            related: 'Benzer Ürünler',
            relatedEmpty: 'Benzer ürün bulunamadı.',
            detailsLoading: 'Ürün detayları yükleniyor...',
            notFound: 'Ürün bulunamadı.',
            selectImageAria: 'Ürün görseli seç',
            allDeliveredNote: 'İstanbul teslimat bölgesi için hesaplanmıştır.',
            promoTitle: 'Ürün Kampanyaları',
            promoFreeCargo: '350 TL üzeri ücretsiz kargo',
            promoOffer: '3 Al 2 Öde fırsatı',
            storeButton: 'Mağazaya Git',
            size: 'Beden',
            color: 'Renk',
            qtyDecrease: 'Adet azalt',
            qtyIncrease: 'Adet artır',
            highlight1: 'Yumuşak dokulu kumaş',
            highlight2: 'Günlük kullanıma uygun tasarım',
            highlight3: 'Sezon kombinleriyle kolay uyum',
            deliveryRange: '{{start}} - {{end}} arası tahmini teslim',
            photoReviewsAria: '{{count}} fotolu yorum'
        },
        feedback: {
            reviews: 'Yorumlar',
            qa: 'Soru-Cevap',
            question: 'Soru',
            answer: 'Cevap',
            photos: 'Fotoğraflar',
            productImageAlt: 'Ürün görseli',
            reviewPhotoAlt: '{{user}} yorum fotoğrafı',
            reviewPhotoPlainAlt: 'Yorum fotoğrafı',
            reviewThumbAlt: 'Yorum fotoğrafı küçük önizleme',
            photoModalTitle: '{{user}} - Fotoğraflar'
        },
        cart: {
            title: 'Sepetim',
            productCount: '{{count}} ürün',
            orderDone: 'Siparişiniz alındı. Teşekkür ederiz.',
            empty: 'Sepetinizde ürün bulunmuyor.',
            size: 'Beden',
            color: 'Renk',
            removeAria: 'Ürünü sepetten kaldır',
            suggestTitle: 'Bunlara da bakmak isteyebilirsiniz',
            addressTitle: 'Adres Seçimi',
            homeAddress: 'Ev Adresi',
            workAddress: 'İş Adresi',
            addressDetailFallback: 'Adres detayı bulunamadı',
            noAddressInAccount: 'Hesabınızda kayıtlı adres bulunamadı.',
            goAddressPage: 'Adreslerimi Yönet',
            paymentTitle: 'Ödeme Yöntemi',
            creditCard: 'Kredi / Banka Kartı',
            cardDetail: 'Tek çekim veya taksit seçenekleri',
            transfer: 'Havale / EFT',
            transferDetail: 'Sipariş öncesi banka transferi ile ödeme',
            door: 'Kapıda Ödeme',
            doorDetail: 'Teslimatta ödeme (ek hizmet bedeli uygulanabilir)',
            cardNo: 'Kart Numarası',
            cardHolder: 'Kart Üzerindeki İsim Soyisim',
            expiry: 'Son Kullanma',
            installments: 'Taksit Seçenekleri',
            summaryTitle: 'Sipariş Özeti',
            subtotal: 'Ara Toplam',
            cargo: 'Kargo',
            free: 'Ücretsiz',
            discount: 'İndirim',
            total: 'Toplam',
            buy: 'Satın Al',
            cash: 'Peşin',
            installmentLabel: '{{count}} taksit',
            bankTitle: 'TrendBank - Güvenli 3D Ödeme',
            close: 'Kapat',
            bankInfo: 'İşleminizi tamamlamak için cep telefonunuza gelen tek kullanımlık şifreyi girin.',
            amount: 'Tutar',
            card: 'Kart',
            secureCode: '3D Secure Kodu',
            otp: 'OTP Kodu',
            otpPlaceholder: '6 haneli kod',
            otpInvalid: 'Girdiğiniz OTP kodu geçersiz. Demo kod: 867245',
            demoText: 'Bu ekran demodur. Gerçek banka işlemi yapılmaz.',
            reject: 'Reddet',
            approveBuy: 'Onayla ve Satın Al',
            loginRedirect: 'Satın alma için giriş yapmalısınız.',
            stepSummary: 'Özet',
            stepAddress: 'Adres',
            stepPayment: 'Ödeme',
            stepConfirm: 'Onay',
            continueAddress: 'Adres Seçimine Geç',
            continuePayment: 'Ödemeye Geç',
            continueConfirm: 'Onaya Geç',
            finalCheckTitle: 'Son Kontrol',
            addAddressInline: 'Yeni Adres Ekle',
            addressFormTitle: 'Adres Başlığı',
            addressPhone: 'Telefon',
            addressCity: 'İl',
            addressDistrict: 'İlçe',
            addressFull: 'Açık Adres',
            saveAddress: 'Adresi Kaydet',
            recentlyViewedTitle: 'Önceden İncelediklerim',
            recentlyViewedEmpty: 'Henüz incelediğin ürün yok. Ürünleri keşfettikçe burada listelenecek.',
            campaignTitle1: 'Sepete Özel İndirim',
            campaignText1: 'Seçili ürünlerde %25’e varan avantajı kaçırma.',
            campaignTitle2: 'Kombin Tamamla',
            campaignText2: 'Bu ürünlerle uyumlu parçaları tek tıkla ekle.',
            campaignTitle3: 'Bugüne Özel Kargo',
            campaignText3: '300 TL üzeri siparişlerde ücretsiz hızlı teslimat.',
            startShopping: 'Alışverişe Başla',
            discountHubTitle: 'Size Özel İndirim Fırsatları',
            discountCircleLabel: 'İndirim',
            prev: 'Önceki',
            next: 'Sonraki',
            mobileCheckoutTitle: 'Güvenli Ödeme',
            back: 'Geri',
            cancel: 'Vazgeç'
        },
        footer: {
            safeShopping: 'Güvenli Alışveriş',
            mobileApps: 'Mobil Uygulamalar',
            socialMedia: 'Sosyal Medya',
            trendBurada: 'Trend Burada',
            about: 'Hakkımızda',
            campaigns: 'Kampanyalar',
            help: 'Yardım',
            whoWeAre: 'Biz Kimiz',
            contact: 'İletişim',
            corporateGift: 'Kurumsal Hediye Çeki',
            career: 'Kariyer',
            activeCampaigns: 'Aktif Kampanyalar',
            membership: 'Üyelik',
            giftIdeas: 'Hediye Fikirleri',
            trendDeals: 'Trend Burada Fırsatları',
            faq: 'Sıkça Sorulan Sorular',
            liveHelp: 'Canlı Yardım',
            howToReturn: 'Nasıl İade Ederim',
            guide: 'İşlem Rehberi'
        },
        breadcrumb: {
            home: 'Anasayfa',
            products: 'Ürünler',
            productDetail: 'Ürün Detayı',
            cart: 'Sepetim',
            favorites: 'Favorilerim',
            account: 'Hesabım',
            login: 'Giriş',
            back: 'Geri',
            ariaLabel: 'Sayfa yolu'
        },
        profile: {
            accountFallback: 'Hesabım',
            groupAccount: 'Kullanıcı Hesabım',
            groupOrders: 'Siparişlerim',
            groupSpecial: 'Sana Özel',
            userInfo: 'Hesap Bilgilerim',
            addresses: 'Adres Bilgilerim',
            cards: 'Kayıtlı Kartlarım',
            allOrders: 'Tüm Siparişlerim',
            sellerMessages: 'Satıcı Mesajları',
            myReviews: 'Değerlendirmelerim',
            buyAgain: 'Yeniden Satın Al',
            coupons: 'İndirim Kuponlarım',
            history: 'Önceden Gezdiklerim',
            followedStores: 'Takip Ettiğim Mağazalar',
            accountInfoTitle: 'Hesap Bilgilerim',
            accountInfoSubtitle: 'Üyelik bilgilerinizi ve şifrenizi buradan yönetebilirsiniz.',
            sectionTitleAddress: 'Adres Bilgilerim',
            sectionSubtitleAddress: 'Kayıtlı teslimat ve fatura adreslerinizi düzenleyin.',
            sectionTitleCards: 'Kayıtlı Kartlarım',
            sectionSubtitleCards: 'Ödemelerde kullanmak için kartlarınızı güvenle saklayın.',
            sectionTitleOrders: 'Tüm Siparişlerim',
            sectionSubtitleOrders: 'Geçmiş siparişlerinizin durumlarını buradan takip edin.',
            sectionTitleMessages: 'Satıcı Mesajları',
            sectionSubtitleMessages: 'Satıcılarla yaptığınız yazışmaları görüntüleyin.',
            sectionTitleReviews: 'Değerlendirmelerim',
            sectionSubtitleReviews: 'Ürün değerlendirme ve yorum geçmişinizi yönetin.',
            sectionTitleBuyAgain: 'Yeniden Satın Al',
            sectionSubtitleBuyAgain: 'Sık aldığınız ürünleri hızlıca tekrar sepete ekleyin.',
            sectionTitleCoupons: 'İndirim Kuponlarım',
            sectionSubtitleCoupons: 'Size tanımlı kupon ve kampanya haklarınızı görüntüleyin.',
            sectionTitleHistory: 'Önceden Gezdiklerim',
            sectionSubtitleHistory: 'Yakın zamanda ziyaret ettiğiniz ürünleri tekrar inceleyin.',
            sectionTitleFollowed: 'Takip Ettiğim Mağazalar',
            sectionSubtitleFollowed: 'Takip ettiğiniz mağaza güncellemelerini buradan görün.',
            noOrdersText: 'Henüz sipariş bulunmuyor.',
            noViewedText: 'Henüz incelediğiniz ürün bulunmuyor.',
            orderTotal: 'Toplam',
            membershipInfo: 'Üyelik Bilgilerim',
            name: 'Ad',
            surname: 'Soyad',
            email: 'E-Posta',
            phone: 'Cep Telefonu',
            birthDate: 'Doğum Tarihi',
            birthDatePlaceholder: 'GG.AA.YYYY',
            gender: 'Cinsiyet',
            genderUnspecified: 'Belirtmek İstemiyorum',
            genderFemale: 'Kadın',
            genderMale: 'Erkek',
            update: 'Güncelle',
            passwordUpdate: 'Şifre Güncelleme',
            currentPassword: 'Mevcut Şifre',
            newPassword: 'Yeni Şifre',
            repeatPassword: 'Yeni Şifre Tekrar',
            demoComponent: 'Demo Bileşen',
            demoComponentText: 'Bu alan ilgili modül için örnek içerik panelidir.',
            quickAction: 'Hızlı İşlem',
            quickActionText: 'Filtreleme, arama, aksiyon butonları bu panelde yer alacak.',
            statusBox: 'Durum Kutusu',
            statusBoxText: 'Aktif kayıtlar, istatistikler ve özet bilgiler burada gösterilecek.',
            noUserTitle: 'Kullanıcı Bilgisine Erişilemedi.',
            noUserDetail: 'Sistemsel bir hata sebebi ile şu an için bilgilerinize erişemiyoruz. Lütfen daha sonra tekrar deneyiniz.',
            readonlyTooltip: 'Bu alanlar kullanıcı tarafından güncellenemez. Lütfen müşteri hizmetleri ile iletişime geçiniz.',
            addAddress: 'Yeni Adres Ekle',
            addressEmpty: 'Henüz kayıtlı adresiniz bulunmuyor.',
            defaultAddress: 'Varsayılan',
            setDefault: 'Varsayılan Yap',
            editAddress: 'Düzenle',
            deleteAddress: 'Sil',
            newAddressTitle: 'Yeni Adres',
            editAddressTitle: 'Adresi Düzenle',
            addressTitle: 'Adres Başlığı',
            addressType: 'Adres Tipi',
            homeType: 'Ev',
            workType: 'İş',
            homeAddressType: 'Ev Adresi',
            workAddressType: 'İş Adresi',
            nameSurname: 'Ad Soyad',
            city: 'İl',
            district: 'İlçe',
            fullAddressLabel: 'Açık Adres',
            saveAddress: 'Adresi Kaydet',
            cancel: 'Vazgeç',
            homeAddressTitle: 'Ev Adresim',
            addressCardFallbackTitle: 'Teslimat Adresim',
            addressFormErrorTitle: 'Eksik Bilgi',
            addressFormErrorDetail: 'Lütfen adres formundaki zorunlu alanları doldurun.',
            contactPreferences: 'İletişim Tercihlerim',
            contactInfo: 'İletişim Bilgisi',
            phoneTab: 'Cep Telefonu',
            phoneTabInfo: 'Telefon numaranızı doğrulama kodu ile güvenli şekilde güncelleyebilirsiniz.',
            currentPhone: 'Mevcut Telefon',
            newPhone: 'Yeni Telefon',
            sendPhoneOtp: 'SMS Kodu Gönder',
            phoneOtpTitle: 'SMS Doğrulama',
            phoneOtpInfo: 'Numaranızı doğrulamak için telefonunuza SMS kodu gönderildi.',
            phoneOtpDemoCode: 'Demo SMS Kodu',
            phoneOtpCode: 'SMS Kodu',
            phoneOtpPlaceholder: '6 haneli kod',
            phoneOtpApprove: 'Onayla',
            phoneOtpInvalid: 'Doğrulama kodu hatalı. Demo kod: 428613',
            phoneInvalidTitle: 'Geçersiz Telefon',
            phoneInvalidDetail: 'Lütfen geçerli bir cep telefonu numarası girin.',
            phoneUpdatedTitle: 'Başarılı',
            phoneUpdatedDetail: 'Cep telefonu numaranız güncellendi.',
            passwordHintAccount: 'Şifreniz en az bir harf, rakam veya özel karakter içermeli ve en az 8 karakterden oluşmalıdır.'
        }
    },
    en: {
        topbar: {
            campaigns: 'Campaigns',
            orders: 'My Orders',
            about: 'About Us',
            newSeason: 'New Season',
            categoriesAria: 'Product categories',
            searchPlaceholder: 'Search for products',
            login: 'Sign In',
            account: 'My Account',
            favorites: 'Favorites',
            cart: 'My Cart',
            cartAria: '{{count}} items in cart',
            collectionSuffix: 'Collection',
            viewAll: 'View All',
            promoBadge: 'New Season',
            promoTitle: 'A Fresh Touch for City Style',
            promoText: 'Discover standout pieces with premium fabrics, timeless cuts and limited stock offers.',
            promoCta: 'Explore Collection',
            promoImageAlt: 'New season campaign image',
            profileAccount: 'My Account',
            profileOrders: 'My Orders',
            profileAddresses: 'My Addresses',
            profileReviews: 'My Reviews',
            profileMessages: 'Seller Messages',
            logout: 'Log Out',
            language: 'Language'
        },
        home: {
            heroPill: 'Trend Burada Special',
            heroText: 'Discover the standout pieces of the season.',
            featuredCollections: 'Featured Collections',
            allCampaigns: 'All Campaigns',
            categorySpotlightTitle: 'Explore Categories',
            discountTitle: 'Discount Campaigns',
            discoverTitle: 'Find pieces matching your style on one screen.',
            specialOffers: 'Special Offers for You',
            seeAll: 'See All'
        },
        common: {
            previousSlide: 'Previous slide',
            nextSlide: 'Next slide',
            suggestions: 'Suggestions',
            passwordRuleLower: 'At least one lowercase letter',
            passwordRuleUpper: 'At least one uppercase letter',
            passwordRuleNumeric: 'At least one number',
            passwordRuleMin: 'Minimum 7 characters'
        },
        loginPage: {
            title: 'Sign In to Your Account',
            subtitle: 'Track orders, save favorites and never miss personalized deals.',
            loginTab: 'Sign In',
            registerTab: 'Sign Up'
        },
        login: {
            email: 'Email',
            emailPlaceholder: 'Email Address',
            password: 'Password',
            passwordPlaceholder: 'Password',
            forgot: 'Forgot Password',
            submit: 'Sign In',
            or: 'or',
            facebook: 'Continue with Facebook',
            google: 'Continue with Google',
            invalidCreds: 'Invalid username or password',
            invalidEmail: 'Please enter a valid email address',
            invalidPassword: 'Please enter your password'
        },
        register: {
            name: 'First Name',
            surname: 'Last Name',
            email: 'Email',
            password: 'Password',
            submit: 'Sign Up',
            success: 'Registration successful. You can now sign in from the Sign In tab.',
            genericError: 'An error occurred during registration.',
            invalidEmail: 'Please enter a valid email address',
            invalidName: 'Please enter your first name',
            invalidSurname: 'Please enter your last name',
            invalidPassword: 'Please enter your password',
            weakPassword: 'Please choose a stronger password',
            passwordHint: 'Password must be at least 7 characters and include letters and symbols.',
            or: 'or',
            facebook: 'Continue with Facebook',
            google: 'Continue with Google'
        },
        favorites: {
            title: 'My Favorites',
            productCount: '{{count}} items',
            loading: 'Loading favorites...',
            emptyTitle: 'You have no favorite products yet',
            emptyText: 'Click the heart icon on products you like to add them here.',
            startShopping: 'Start Shopping'
        },
        productList: {
            listingCount: '{{count}} products listed',
            loading: 'Loading products...',
            empty: 'No products found for selected filters. Try a different combination.'
        },
        productCard: {
            fastDelivery: 'Fast Delivery',
            addFavorite: 'Add to favorites',
            removeFavorite: 'Remove from favorites',
            sellerScore: 'Seller Score',
            freeCargo: 'Free Shipping'
        },
        productFilter: {
            categories: 'Categories',
            searchPlaceholder: 'Search {{title}}',
            noResult: 'No results found',
            showFilters: 'Show Filters',
            hideFilters: 'Hide Filters',
            clearFilters: 'Clear',
            apply: 'Apply',
            cancel: 'Cancel',
            mobileFilterAria: 'Filter tabs',
            brand: 'Brand',
            size: 'Size',
            color: 'Color',
            price: 'Price',
            rating: 'Rating',
            sellerScore: 'Seller Score',
            discount: 'Discount',
            delivery: 'Delivery',
            shipping: 'Shipping',
            paymentOption: 'Payment Option'
        },
        productDetail: {
            home: 'Home',
            reviewsLabel: 'reviews',
            qaLabel: 'Q&A',
            fastDelivery: 'Fast Delivery',
            freeCargo: 'Free Shipping',
            seller: 'Seller',
            sellerStoreSuffix: 'Store',
            sellerScore: 'Seller score',
            estimatedDelivery: 'Estimated Delivery',
            addToCart: 'Add to Cart',
            addedToCart: 'Product added to cart.',
            productFeatures: 'Product Features',
            summary: 'Product Summary',
            summaryText: '{{title}} stands out with a modern cut and comfortable structure for daily use.',
            discount: '{{count}}% discount',
            feedbackTitle: 'Reviews and Q&A',
            related: 'Similar Products',
            relatedEmpty: 'No similar products found.',
            detailsLoading: 'Loading product details...',
            notFound: 'Product not found.',
            selectImageAria: 'Select product image',
            allDeliveredNote: 'Calculated for Istanbul delivery region.',
            promoTitle: 'Product Campaigns',
            promoFreeCargo: 'Free shipping over 350 TL',
            promoOffer: 'Buy 3 Pay 2 offer',
            storeButton: 'Go to Store',
            size: 'Size',
            color: 'Color',
            qtyDecrease: 'Decrease quantity',
            qtyIncrease: 'Increase quantity',
            highlight1: 'Soft textured fabric',
            highlight2: 'Suitable design for daily use',
            highlight3: 'Easy match with seasonal outfits',
            deliveryRange: 'Estimated delivery between {{start}} - {{end}}',
            photoReviewsAria: '{{count}} photo reviews'
        },
        feedback: {
            reviews: 'Reviews',
            qa: 'Q&A',
            question: 'Question',
            answer: 'Answer',
            photos: 'Photos',
            productImageAlt: 'Product image',
            reviewPhotoAlt: '{{user}} review photo',
            reviewPhotoPlainAlt: 'Review photo',
            reviewThumbAlt: 'Review photo thumbnail',
            photoModalTitle: '{{user}} - Photos'
        },
        cart: {
            title: 'My Cart',
            productCount: '{{count}} items',
            orderDone: 'Your order has been placed. Thank you.',
            empty: 'Your cart is empty.',
            size: 'Size',
            color: 'Color',
            removeAria: 'Remove product from cart',
            suggestTitle: 'You may also like',
            addressTitle: 'Address Selection',
            homeAddress: 'Home Address',
            workAddress: 'Work Address',
            addressDetailFallback: 'Address details are unavailable',
            noAddressInAccount: 'No saved address found in your account.',
            goAddressPage: 'Manage My Addresses',
            paymentTitle: 'Payment Method',
            creditCard: 'Credit / Debit Card',
            cardDetail: 'Single payment or installment options',
            transfer: 'Wire Transfer / EFT',
            transferDetail: 'Pay by bank transfer before checkout',
            door: 'Cash on Delivery',
            doorDetail: 'Pay at delivery (service fee may apply)',
            cardNo: 'Card Number',
            cardHolder: 'Cardholder Name',
            expiry: 'Expiry Date',
            installments: 'Installment Options',
            summaryTitle: 'Order Summary',
            subtotal: 'Subtotal',
            cargo: 'Shipping',
            free: 'Free',
            discount: 'Discount',
            total: 'Total',
            buy: 'Buy Now',
            cash: 'Cash',
            installmentLabel: '{{count}} installments',
            bankTitle: 'TrendBank - Secure 3D Payment',
            close: 'Close',
            bankInfo: 'Enter the one-time password sent to your mobile phone to complete the payment.',
            amount: 'Amount',
            card: 'Card',
            secureCode: '3D Secure Code',
            otp: 'OTP Code',
            otpPlaceholder: '6-digit code',
            otpInvalid: 'Invalid OTP code. Demo code: 867245',
            demoText: 'This is a demo screen. No real bank transaction is made.',
            reject: 'Reject',
            approveBuy: 'Approve and Buy',
            loginRedirect: 'You must sign in to complete purchase.',
            stepSummary: 'Summary',
            stepAddress: 'Address',
            stepPayment: 'Payment',
            stepConfirm: 'Confirm',
            continueAddress: 'Continue to Address',
            continuePayment: 'Continue to Payment',
            continueConfirm: 'Continue to Confirmation',
            finalCheckTitle: 'Final Review',
            addAddressInline: 'Add New Address',
            addressFormTitle: 'Address Title',
            addressPhone: 'Phone',
            addressCity: 'City',
            addressDistrict: 'District',
            addressFull: 'Full Address',
            saveAddress: 'Save Address',
            recentlyViewedTitle: 'Recently Viewed',
            recentlyViewedEmpty: 'You do not have any viewed products yet. They will appear here as you browse.',
            campaignTitle1: 'Cart Special Discount',
            campaignText1: 'Catch up to 25% advantage on selected products.',
            campaignTitle2: 'Complete Your Outfit',
            campaignText2: 'Add matching pieces for your style in one click.',
            campaignTitle3: 'Today Only Shipping',
            campaignText3: 'Free fast delivery for orders over 300 TL.',
            startShopping: 'Start Shopping',
            discountHubTitle: 'Special Discount Deals for You',
            discountCircleLabel: 'Discount',
            prev: 'Previous',
            next: 'Next',
            mobileCheckoutTitle: 'Secure Checkout',
            back: 'Back',
            cancel: 'Cancel'
        },
        footer: {
            safeShopping: 'Secure Shopping',
            mobileApps: 'Mobile Apps',
            socialMedia: 'Social Media',
            trendBurada: 'Trend Burada',
            about: 'About Us',
            campaigns: 'Campaigns',
            help: 'Help',
            whoWeAre: 'Who We Are',
            contact: 'Contact',
            corporateGift: 'Corporate Gift Card',
            career: 'Career',
            activeCampaigns: 'Active Campaigns',
            membership: 'Membership',
            giftIdeas: 'Gift Ideas',
            trendDeals: 'Trend Burada Deals',
            faq: 'Frequently Asked Questions',
            liveHelp: 'Live Support',
            howToReturn: 'How to Return',
            guide: 'Process Guide'
        },
        breadcrumb: {
            home: 'Home',
            products: 'Products',
            productDetail: 'Product Detail',
            cart: 'My Cart',
            favorites: 'Favorites',
            account: 'My Account',
            login: 'Sign In',
            back: 'Back',
            ariaLabel: 'Breadcrumb'
        },
        profile: {
            accountFallback: 'My Account',
            groupAccount: 'User Account',
            groupOrders: 'My Orders',
            groupSpecial: 'For You',
            userInfo: 'My User Info',
            addresses: 'My Addresses',
            cards: 'Saved Cards',
            allOrders: 'All Orders',
            sellerMessages: 'Seller Messages',
            myReviews: 'My Reviews',
            buyAgain: 'Buy Again',
            coupons: 'My Coupons',
            history: 'Recently Viewed',
            followedStores: 'Followed Stores',
            accountInfoTitle: 'Account Information',
            accountInfoSubtitle: 'Manage your membership details and password here.',
            sectionTitleAddress: 'Address Information',
            sectionSubtitleAddress: 'Manage your delivery and billing addresses.',
            sectionTitleCards: 'Saved Cards',
            sectionSubtitleCards: 'Store your cards securely for payments.',
            sectionTitleOrders: 'All Orders',
            sectionSubtitleOrders: 'Track the status of your past orders.',
            sectionTitleMessages: 'Seller Messages',
            sectionSubtitleMessages: 'View your conversations with sellers.',
            sectionTitleReviews: 'My Reviews',
            sectionSubtitleReviews: 'Manage your product reviews and ratings.',
            sectionTitleBuyAgain: 'Buy Again',
            sectionSubtitleBuyAgain: 'Quickly add frequently bought products to cart.',
            sectionTitleCoupons: 'My Coupons',
            sectionSubtitleCoupons: 'View your available coupons and campaign rights.',
            sectionTitleHistory: 'Recently Viewed',
            sectionSubtitleHistory: 'Revisit products you viewed recently.',
            sectionTitleFollowed: 'Followed Stores',
            sectionSubtitleFollowed: 'See updates from stores you follow.',
            noOrdersText: 'You have no orders yet.',
            noViewedText: 'You have not viewed any products yet.',
            orderTotal: 'Total',
            membershipInfo: 'My Membership Info',
            name: 'First Name',
            surname: 'Last Name',
            email: 'Email',
            phone: 'Mobile Phone',
            birthDate: 'Birth Date',
            birthDatePlaceholder: 'DD.MM.YYYY',
            gender: 'Gender',
            genderUnspecified: 'Prefer not to say',
            genderFemale: 'Female',
            genderMale: 'Male',
            update: 'Update',
            passwordUpdate: 'Password Update',
            currentPassword: 'Current Password',
            newPassword: 'New Password',
            repeatPassword: 'Repeat New Password',
            demoComponent: 'Demo Component',
            demoComponentText: 'This area is a sample content panel for the related module.',
            quickAction: 'Quick Action',
            quickActionText: 'Filtering, search and action buttons will be placed in this panel.',
            statusBox: 'Status Box',
            statusBoxText: 'Active records, statistics and summary info will be displayed here.',
            noUserTitle: 'User Info Could Not Be Accessed.',
            noUserDetail: 'We cannot access your information right now due to a system issue. Please try again later.',
            readonlyTooltip: 'These fields cannot be updated by users. Please contact customer support.',
            addAddress: 'Add New Address',
            addressEmpty: 'You have no saved addresses yet.',
            defaultAddress: 'Default',
            setDefault: 'Set Default',
            editAddress: 'Edit',
            deleteAddress: 'Delete',
            newAddressTitle: 'New Address',
            editAddressTitle: 'Edit Address',
            addressTitle: 'Address Title',
            addressType: 'Address Type',
            homeType: 'Home',
            workType: 'Work',
            homeAddressType: 'Home Address',
            workAddressType: 'Work Address',
            nameSurname: 'Full Name',
            city: 'City',
            district: 'District',
            fullAddressLabel: 'Full Address',
            saveAddress: 'Save Address',
            cancel: 'Cancel',
            homeAddressTitle: 'Home Address',
            addressCardFallbackTitle: 'Delivery Address',
            addressFormErrorTitle: 'Missing Information',
            addressFormErrorDetail: 'Please fill in the required fields in the address form.',
            contactPreferences: 'Contact Preferences',
            contactInfo: 'Contact Info',
            phoneTab: 'Mobile Phone',
            phoneTabInfo: 'You can securely update your phone number with SMS verification.',
            currentPhone: 'Current Phone',
            newPhone: 'New Phone',
            sendPhoneOtp: 'Send SMS Code',
            phoneOtpTitle: 'SMS Verification',
            phoneOtpInfo: 'An SMS verification code has been sent to your phone.',
            phoneOtpDemoCode: 'Demo SMS Code',
            phoneOtpCode: 'SMS Code',
            phoneOtpPlaceholder: '6-digit code',
            phoneOtpApprove: 'Confirm',
            phoneOtpInvalid: 'Verification code is invalid. Demo code: 428613',
            phoneInvalidTitle: 'Invalid Phone',
            phoneInvalidDetail: 'Please enter a valid mobile phone number.',
            phoneUpdatedTitle: 'Success',
            phoneUpdatedDetail: 'Your mobile phone number has been updated.',
            passwordHintAccount: 'Your password must include letters, numbers or special characters and be at least 8 characters long.'
        }
    }
};
